module.exports = __webpack_public_path__ + "images/emoji/pencil2.6fbcedf6f99b2d41c883.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/pencil2.png
// module id = xXHh
// module chunks = 13